import { PageableData, Paginator } from "../shared/models/paginator";

// skipcq: JS-0327
export class PageableFunctions {

    /**
    * A function that get the pageable of a paginator ,note: For infinite scroll send previous data
    * @returns {PageableData<T>}
    */
    public static getPageableData<T>(data: Paginator<T>, previousData?: T[]): PageableData<T> {
        const newData = previousData ? previousData.concat(data.content) : data.content;
        const pageable: PageableData<T> = {
            content: newData,
            itemsQuantity: newData.length,
            currentPage: data.number + 1,
            totalPages: data.totalPages,
            totalElements: data.totalElements
        }
        return pageable;
    }
}